<main class="flex flex-column justify-content-center align-items-center">
  <qa-user-form [userData]="currentUser"/>
</main>


